// admin.work-units.tsx
// Route : /admin/work-units — Gestion des référentiels unités de travail et phases de travail.

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { AdminWorkUnitsPage } from "@/presentation/pages/AdminWorkUnitsPage";

const adminWorkUnitsSearchSchema = z.object({
  tab: z.enum(["physical", "psychosocial"]).default("physical"),
});

function AdminWorkUnitsRoute() {
  return <AdminWorkUnitsPage initialTab={Route.useSearch().tab} />;
}

export const Route = createFileRoute("/admin/work-units")({
  validateSearch: (search: Record<string, unknown>) => adminWorkUnitsSearchSchema.parse(search),
  component: AdminWorkUnitsRoute,
});
